import React, { useState } from 'react'
import { ButtonGroup } from '@pandiafi/design-system'
import classNames from 'classnames'

import i18n, { changeI18nLanguage } from 'i18n/i18n'

interface LanguageSelectorProps {
  mobile?: boolean
  className?: string
}

const languages = [
  {
    id: 'fi',
    label: 'FI',
  },
  {
    id: 'sv',
    label: 'SV',
  },
  {
    id: 'en',
    label: 'EN',
  },
]

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  mobile,
  className,
}) => {
  const [currentLang, setCurrentLang] = useState(i18n.language)

  const handleOnChange = (lang?: string) => {
    switch (lang) {
      case 'sv':
        changeI18nLanguage('sv')
        setCurrentLang('sv')
        break
      case 'en':
        changeI18nLanguage('en')
        setCurrentLang('en')
        break
      case 'fi':
      default:
        changeI18nLanguage('fi')
        setCurrentLang('fi')
        break
    }
  }

  return mobile ? (
    <ButtonGroup
      fullwidth
      small
      className={classNames(className, 'space-x-3')}
      variant="text"
      onChange={(value) => handleOnChange(value)}
      value={currentLang}
      suggestions={languages}
    />
  ) : (
    <ButtonGroup
      className={classNames(className, 'space-x-2')}
      variant="text"
      onChange={(value) => handleOnChange(value)}
      value={currentLang}
      suggestions={languages}
    />
  )
}

export default LanguageSelector
